import { render } from "./Chanpin2.vue?vue&type=template&id=133533bc&scoped=true"
import script from "./Chanpin2.vue?vue&type=script&lang=js"
export * from "./Chanpin2.vue?vue&type=script&lang=js"

import "./Chanpin2.vue?vue&type=style&index=0&id=133533bc&scoped=true&lang=css"

import exportComponent from "D:\\lxq\\nkpcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-133533bc"]])

export default __exports__